import { f as formatMoney } from "./currency-DRNmrEpZ.js";
class FreeShippingIndicator extends HTMLElement {
  constructor() {
    super();
  }
  static get observedAttributes() {
    return ["cart-value"];
  }
  connectedCallback() {
    const threshold = window.themeVars.config.freeShippingIndicator.threshold;
    if (!threshold) {
      return;
    }
    this.render();
  }
  attributeChangedCallback(name) {
    const threshold = window.themeVars.config.freeShippingIndicator.threshold;
    if (!threshold) {
      return;
    }
    if (name === "cart-value") {
      this.render();
    }
  }
  render() {
    const cartValueAttribute = this.getAttribute("cart-value");
    const totalPrice = cartValueAttribute ? parseInt(cartValueAttribute, 10) : 0;
    const threshold = window.themeVars.config.freeShippingIndicator.threshold;
    const textClass = this.getAttribute("text-class") || "text-md-body--semi-bold";
    const progressBarWidth = this.getBarWidth(totalPrice, threshold);
    let textString = this.getTextString(totalPrice, threshold);
    const thresholdMet = progressBarWidth === 100 ? true : false;
    this.setAttribute("threshold-met", `${thresholdMet}`);
    let html = `
      <div
        class="free-shipping-indicator"
        js-free-shipping-indicator
      >
        <p class="
          free-shipping-indicator__title
          ${textClass}
        ">
          ${textString}
        </p>

        <div class="free-shipping-indicator__track">
          <div
            class="free-shipping-indicator__progress"
            style="width: ${progressBarWidth}%"
          ></div>
        </div>
      </div>
    `;
    const showSuccessMessage = this.getAttribute("show-success-message");
    if (showSuccessMessage && totalPrice >= threshold) {
      textString = window.themeVars.strings.freeShippingIndicator.successMessage;
      html = `
        <div
          class="
            free-shipping-indicator
            free-shipping-indicator--success
          "
          js-free-shipping-indicator
          threshold-met="true"
        >
          <p class="
            free-shipping-indicator__title
            ${textClass}
          ">
            ${window.themeVars.icons.thumb}
            ${textString}
          </p>
        </div>
      `;
    }
    this.innerHTML = html;
  }
  getBarWidth(totalPrice, threshold) {
    if (totalPrice <= 0) {
      return 0;
    }
    if (totalPrice >= threshold) {
      return 100;
    }
    const achievedPercentage = totalPrice / threshold * 100;
    return achievedPercentage;
  }
  getTextString(totalPrice, threshold) {
    const amountLeft = threshold - totalPrice;
    const moneyFormattedAmountLeft = formatMoney(amountLeft, true, true);
    const spendMoreString = window.themeVars.strings.freeShippingIndicator.spendMore.replace(
      "{{ amount }}",
      moneyFormattedAmountLeft
    );
    if (totalPrice <= 0) {
      return spendMoreString;
    }
    if (totalPrice >= threshold) {
      return window.themeVars.strings.freeShippingIndicator.achievedFreeShipping;
    }
    return spendMoreString;
  }
}
customElements.define("uwp-free-shipping-indicator", FreeShippingIndicator);
